module.exports = __webpack_public_path__ + "img/audio-pause.4139177e.png";